import { siteConfig } from '../data/siteConfig';
import type { ReviewerRelationship } from '../types/content';
import type { SubmitResult } from './submitInquiry';

export type PublishPreference = 'named' | 'anonymous' | 'private';

export interface ReviewPayload {
  name: string;
  email: string;
  title: string;
  company: string;
  relationship: ReviewerRelationship;
  experience: string;
  publishPreference: PublishPreference;
}

/** Sends a review for moderation. Only resolves to `success` on a 2xx response. */
export async function submitReview(payload: ReviewPayload): Promise<SubmitResult> {
  const endpoint = siteConfig.reviewEndpoint.trim();
  if (!endpoint) return { status: 'not-configured' };

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...payload, type: 'review', submittedAt: new Date().toISOString() }),
    });
    if (response.ok) return { status: 'success' };
    return { status: 'error', message: `We couldn't save your review (error ${response.status}). Please try again shortly.` };
  } catch {
    return { status: 'error', message: 'We couldn’t reach our review service. Check your connection and try again.' };
  }
}
